'use client';

import { GoogleAnalytics } from '@next/third-parties/google';

const gaId = process.env.NEXT_PUBLIC_GA_ID;

interface AnalyticsProps {
  nonce?: string;
}

export function Analytics({ nonce }: AnalyticsProps) {
  if (!gaId) {
    return null;
  }

  return <GoogleAnalytics gaId={gaId} nonce={nonce} />;
}


